import { createIcon } from './createIcon';

/**
 * Privacy — a shield. The one mark that reads as "what we keep about you" at
 * 16px; a lock says "signed in" beside an account row, and an eye says
 * "visible", which is the opposite of what this pane controls.
 */
export const PrivacyIcon = createIcon({
  name: 'PrivacyIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <path
      d="M8 1.75 3.25 3.5v4.25c0 3 2 5.3 4.75 6.5 2.75-1.2 4.75-3.5 4.75-6.5V3.5L8 1.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  ),
});

export default PrivacyIcon;
